const theme = {
  fontFamily: "Cabin",
  headings: { fontFamily: "Cabin" },
  primaryColor: "green",
};

export default theme;
